import { render, staticRenderFns } from "./SearchTemplate.vue?vue&type=template&id=e2ead38a&scoped=true&"
var script = {}
import style0 from "./SearchTemplate.vue?vue&type=style&index=0&id=e2ead38a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ead38a",
  null
  
)

export default component.exports